<template>
    <div class="floating-menu" v-if="visible" :style="containerStyles">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        position: {
            type: Object,
            default: {
                bottom: 0,
                top: 0
            }
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        containerStyles() {
            return this.position
        }
    }
}
</script>

<style lang="scss" scoped>
    .floating-menu {
        zoom: 1;
        background: #fff;
        border: 1px solid #a5b2bd;
        border-radius: 6px;
        box-shadow: 0 1px 7px 0 rgba(0,0,0,.08);
        display: block;
        position: fixed;
        z-index: 49;
        left: 50%;
        transform: translateX(-50%);
        padding: .5rem;

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
            li { display: inline-block; }
        }
    }
</style>